<template>
  <span v-if="total > 0" class="an-share" :title="title">
    <span class="an-share__part an-share__part--good" :style="{ width: pct(good) }"></span>
    <span class="an-share__part an-share__part--ni" :style="{ width: pct(ni) }"></span>
    <span class="an-share__part an-share__part--poor" :style="{ width: pct(poor) }"></span>
  </span>
</template>

<script>
import {formatPercent} from "@/common/rumFormat";

/**
 * Полоска «зелёная / жёлтая / красная зона». Доли посетителей присылает сайт,
 * здесь ничего не оценивается — только рисуется.
 */
export default {
  name: "RumShareBar",
  props: {
    good: {type: Number, default: 0},
    ni: {type: Number, default: 0},
    poor: {type: Number, default: 0},
  },
  computed: {
    total() {
      return this.good + this.ni + this.poor
    },
    title() {
      return `Хорошо: ${formatPercent(this.good)} · терпимо: ${formatPercent(this.ni)} · плохо: ${formatPercent(this.poor)}`
    },
  },
  methods: {
    pct(share) {
      return `${(share / this.total) * 100}%`
    },
  },
}
</script>
